import React from 'react';
import './styles/CorporateRelocation.css';
import { FaStethoscope, FaIdBadge, FaFileAlt, FaPlaneDeparture, FaCarSide } from "react-icons/fa";
import { GiSittingDog } from "react-icons/gi";
import contactBg from '../assets/contact-us.jpg'; // Replace with your background image

const CorporateRelocation = () => {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/918618173141', '_blank');
  };

  return (
    <div className="corporate-relocation-container">
      <div className="services-section">
        <h2 className="section-title">Comprehensive Pet Relocation Services</h2>
        <h3 className="section-subtitle">Our Services</h3>
        <div className="service-list">
          <div className="service-item">
            <FaStethoscope className="service-icon" />
            <h4>Thorough Veterinary Examination</h4>
            <p>We ensure your pet is healthy and travel-ready with complete veterinary health checks before the journey.</p>
          </div>
          <div className="service-item">
            <FaIdBadge className="service-icon" />
            <h4>Microchip Implantation</h4>
            <p>Provide your pet with a safe and quick microchip ID for easy identification and seamless travel.</p>
          </div>
          <div className="service-item">
            <FaFileAlt className="service-icon" />
            <h4>Pet Licensing & Permits</h4>
            <p>We handle all necessary permits and licenses, ensuring your pet meets all travel regulations—stress-free for you.</p>
          </div>
          <div className="service-item">
            <FaCarSide className="service-icon" />
            <h4>At-Home Paperwork Assistance</h4>
            <p>Our team manages all the required documentation right at your doorstep, making the process easy and convenient.</p>
          </div>
        </div>
      </div>
      <div
        className="contact-section"
        style={{ backgroundImage: `url(${contactBg})` }}
      >
        <div className="contact-overlay">
          <h2>Contact MovingBay today to create a safe, and stress-free pet relocation tailored to your needs and budget.

</h2>
          <h3>Have a question?</h3>
          <a href="https://wa.me/918618173141" target="_blank" className="ask-expert-btn" onClick={handleWhatsAppClick}>
            Ask our moving expert
          </a>
        </div>
      </div>
    </div>
  );
};

export default CorporateRelocation;
